/**
 * Mega menu keyboard-accessible dropdowns
 */
(function () {
  document.querySelectorAll('[data-mega-menu]').forEach((menu) => {
    const trigger = menu.querySelector('.mega-menu__trigger');
    const panel = menu.querySelector('.mega-menu__panel');
    if (!trigger || !panel) return;

    function open() {
      document.querySelectorAll('[data-mega-menu].is-open').forEach((m) => {
        if (m !== menu) closeMenu(m);
      });
      menu.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closeMenu(m) {
      m.classList.remove('is-open');
      m.querySelector('.mega-menu__trigger')?.setAttribute('aria-expanded', 'false');
    }

    function close() {
      closeMenu(menu);
    }

    trigger.addEventListener('click', () => {
      menu.classList.contains('is-open') ? close() : open();
    });

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        menu.classList.contains('is-open') ? close() : open();
      }
      if (e.key === 'Escape') close();
    });

    menu.addEventListener('focusout', (e) => {
      if (!menu.contains(e.relatedTarget)) close();
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-mega-menu]')) {
      document.querySelectorAll('[data-mega-menu].is-open').forEach((m) => {
        m.classList.remove('is-open');
        m.querySelector('.mega-menu__trigger')?.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();
